module.exports = __webpack_public_path__ + "img/dash-logs.0623fa0d.png";